import { RouteUrlList } from '@/libs/RouteList';

/**
 * @todo 職業與資產投資 ViewData
 */
const JobAssetInvestmentViewData = [
    'POST',
    RouteUrlList.API_JobAssetInvestmentViewData.path,
    {},
    200,
    {
        status: true,
        title: '資料載入成功',
        message: '取得成功',
        errorCode: '',
        result: {
            occupationCode_Collection: [
                {
                    enum_type: 'Occupation',
                    enum_id: '01',
                    enum_nm: '雇主',
                    enum_desc: '1',
                    enum_memo: ''
                },
                {
                    enum_type: 'Occupation',
                    enum_id: '02',
                    enum_nm: '正職(含約聘、派遣)',
                    enum_desc: '2',
                    enum_memo: ''
                },
                {
                    enum_type: 'Occupation',
                    enum_id: '03',
                    enum_nm: '兼職(含工讀)',
                    enum_desc: '3',
                    enum_memo: ''
                },
                {
                    enum_type: 'Occupation',
                    enum_id: '04',
                    enum_nm: '學生',
                    enum_desc: '4',
                    enum_memo: ''
                },
                {
                    enum_type: 'Occupation',
                    enum_id: '05',
                    enum_nm: '家管',
                    enum_desc: '5',
                    enum_memo: ''
                },
                {
                    enum_type: 'Occupation',
                    enum_id: '06',
                    enum_nm: '退休',
                    enum_desc: '6',
                    enum_memo: ''
                },
                {
                    enum_type: 'Occupation',
                    enum_id: '07',
                    enum_nm: '待業',
                    enum_desc: '7',
                    enum_memo: ''
                },
                {
                    enum_type: 'Occupation',
                    enum_id: '99',
                    enum_nm: '其他',
                    enum_desc: '8',
                    enum_memo: ''
                }
            ],
            occupationCode: '02',
            occupationOther: '',
            occupationId_Collection: [
                {
                    jobid: '01',
                    jobdesc: '營造／礦砂業'
                },
                {
                    jobid: '02',
                    jobdesc: '製造業'
                },
                {
                    jobid: '03',
                    jobdesc: '水電燃氣業'
                },
                {
                    jobid: '04',
                    jobdesc: '批發／零售／貿易商'
                },
                {
                    jobid: '05',
                    jobdesc: '旅宿／餐飲'
                },
                {
                    jobid: '06',
                    jobdesc: '運輸倉儲'
                },
                {
                    jobid: '07',
                    jobdesc: '農／林／漁／牧'
                },
                {
                    jobid: '08',
                    jobdesc: '金融保險'
                },
                {
                    jobid: '09',
                    jobdesc: '不動產／租賃'
                },
                {
                    jobid: '10',
                    jobdesc: '軍／警／消'
                },
                {
                    jobid: '11',
                    jobdesc: '公務人員'
                },
                {
                    jobid: '12',
                    jobdesc: '律師／會計師／地政士'
                },
                {
                    jobid: '13',
                    jobdesc: '醫藥服務'
                },
                {
                    jobid: '14',
                    jobdesc: '休閒服務'
                },
                {
                    jobid: '15',
                    jobdesc: '其他／家管'
                },
                {
                    jobid: '16',
                    jobdesc: '自由業'
                },
                {
                    jobid: '17',
                    jobdesc: '投資／自營商'
                },
                {
                    jobid: '18',
                    jobdesc: '媒體文教'
                },
                {
                    jobid: '19',
                    jobdesc: '學生'
                },
                {
                    jobid: '20',
                    jobdesc: '學校教師（含行政人員）'
                },
                {
                    jobid: '21',
                    jobdesc: '資訊科技'
                },
                {
                    jobid: '22',
                    jobdesc: '公證人或記帳士'
                },
                {
                    jobid: '23',
                    jobdesc: '國防工業'
                },
                {
                    jobid: '24',
                    jobdesc: '投資或稅務顧問公司'
                },
                {
                    jobid: '25',
                    jobdesc: '不動產仲介／代銷商'
                },
                {
                    jobid: '26',
                    jobdesc: '大宗物資貿易商'
                },
                {
                    jobid: '27',
                    jobdesc: '博弈業（網路／實體）'
                },
                {
                    jobid: '28',
                    jobdesc: '八大特種行業'
                },
                {
                    jobid: '29',
                    jobdesc: '宗教、慈善、基金會'
                },
                {
                    jobid: '30',
                    jobdesc: '銀樓、珠寶商'
                },
                {
                    jobid: '31',
                    jobdesc: '藝術品或古董買賣商'
                },
                {
                    jobid: '32',
                    jobdesc: '當鋪'
                },
                {
                    jobid: '33',
                    jobdesc: '虛擬通貨／加密資產業'
                },
                {
                    jobid: '34',
                    jobdesc: '第三方支付服務業'
                },
                {
                    jobid: '35',
                    jobdesc: '線上遊戲事業'
                },
                {
                    jobid: '36',
                    jobdesc: '船舶運送／租賃／燃油'
                },
                {
                    jobid: '37',
                    jobdesc: '報關代理'
                },
                {
                    jobid: '38',
                    jobdesc: '外籍移工匯兌公司'
                }
            ],
            occupationId: '08', // 預設選電子零組件
            commonCityData: [
                {
                    sequence: '10001',
                    city: '台北市'
                },
                {
                    sequence: '20001',
                    city: '基隆市'
                },
                {
                    sequence: '20741',
                    city: '新北市'
                },
                {
                    sequence: '20941',
                    city: '連江縣'
                },
                {
                    sequence: '260',
                    city: '宜蘭縣'
                },
                {
                    sequence: '29041',
                    city: '釣魚臺'
                },
                {
                    sequence: '300012',
                    city: '新竹市'
                },
                {
                    sequence: '30075',
                    city: '新竹縣'
                },
                {
                    sequence: '320',
                    city: '桃園市'
                },
                {
                    sequence: '350012',
                    city: '苗栗縣'
                },
                {
                    sequence: '40001',
                    city: '臺中市'
                },
                {
                    sequence: '50001',
                    city: '彰化縣'
                },
                {
                    sequence: '54001',
                    city: '南投縣'
                },
                {
                    sequence: '60001',
                    city: '嘉義市'
                },
                {
                    sequence: '60241',
                    city: '嘉義縣'
                },
                {
                    sequence: '63041',
                    city: '雲林縣'
                },
                {
                    sequence: '70002',
                    city: '臺南市'
                },
                {
                    sequence: '80002',
                    city: '高雄市'
                },
                {
                    sequence: '81741',
                    city: '南海島'
                },
                {
                    sequence: '880025',
                    city: '澎湖縣'
                },
                {
                    sequence: '890002',
                    city: '金門縣'
                },
                {
                    sequence: '90001',
                    city: '屏東縣'
                },
                {
                    sequence: '950',
                    city: '臺東縣'
                },
                {
                    sequence: '97001',
                    city: '花蓮縣'
                }
            ],
            companyName: '模範科技股份有限公司',
            companyTelephoneExt: '1234',
            companyTelephone: '0227188888',
            contactTelephone: '0227188888',
            mobilephone: '0912345678',
            companyAddressDist: '信義區',
            jobTitleParentCode_Collection: [
                // 假設的職務類別
                {
                    enum_type: 'JobTitleParent',
                    enum_id: '3',
                    enum_nm: '高階管理人員',
                    enum_desc: '1'
                },
                {
                    enum_type: 'JobTitleParent',
                    enum_id: '4',
                    enum_nm: '財務（管理）人員',
                    enum_desc: '2'
                },
                {
                    enum_type: 'JobTitleParent',
                    enum_id: '6',
                    enum_nm: '專業服務人員',
                    enum_desc: '3'
                },
                {
                    enum_type: 'JobTitleParent',
                    enum_id: '7',
                    enum_nm: '專業技術人員',
                    enum_desc: '4'
                },
                {
                    enum_type: 'JobTitleParent',
                    enum_id: '5',
                    enum_nm: '專業人員（具專業執照）',
                    enum_desc: '5'
                },
                {
                    enum_type: 'JobTitleParent',
                    enum_id: '8',
                    enum_nm: '一般及其他職務',
                    enum_desc: '6'
                },
                {
                    enum_type: 'JobTitleParent',
                    enum_id: '2',
                    enum_nm: '政府公職人員',
                    enum_desc: '7'
                },
                {
                    enum_type: 'JobTitleParent',
                    enum_id: '1',
                    enum_nm: '民意代表',
                    enum_desc: '8'
                }
            ],
            jobTitleParentCode: '',
            jobTitleCode: '', // 假設的職務代碼 (例如: 軟體工程師)
            jobTitleOther: '',
            bolInvestmentExp: '',
            yrsStockExp: '',
            yrsBondExp: '',
            yrsRealEstateExp: '',
            yrsFutureExp: '',
            yrsOtherExpDetail: '',
            yrsOtherExp: '',
            amountYearlyIncome: '',
            amountFamilyIncome: '',
            mainMoneySource: '',

            mainMoneySourceDetail: '',
            bolOwnHouse: '',
            amountHouseValue: '',
            bolHasMortgage: '',
            amountMortgage: '',
            bolDepositeMonthEndLeft: '',
            amountDepositeMonthEndLeft: '',
            bolOtherAsset: '',
            otherAssetDetail: '',
            amountOtherAsset: '',
            amountTotalAsset: ''
        }
    }
];
export default JobAssetInvestmentViewData;
